import { useContext, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import BlockGradTemplate from 'app/components/DesignVersion/Grad/Blocks/BlockGradTemplate';
import TeamAvatar from 'app/components/TeamAvatar';
import { formatDate } from 'app/utils/date';
import ConfigContext from 'app/common/ConfigContext';
import { getMatchType } from 'app/utils/entities/match_data';

import style from './style.module.scss';

interface Props {
  data: HeadToHeadBlockMatch;
}

const HeadToHeadBlockGrad: FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const { lang } = useContext(ConfigContext);

  const opponent1 = data.opponents.at(0);
  const opponent2 = data.opponents.at(1);

  return (
    <BlockGradTemplate
      hasData={Boolean(data.encounters?.length)}
      contentClassName={style.h2HContent}
      title={t('blocks_head-to-head_title')}
    >
      <div className={style.h2HHeader}>
        <span>{t('block-head_to_head-format')}</span>
        <span>{t('block-head_to_head-score')}</span>
        <span>{t('block-head_to_head-date')}</span>
      </div>
      <ul className={style.h2HEncountersList}>
        {data.encounters.map(encounter => {
          const opponent1Encounter = encounter.opponents.find(
            opponent => opponent.id === opponent1?.id
          );
          const opponent2Encounter = encounter.opponents.find(
            opponent => opponent.id === opponent2?.id
          );

          return (
            <li key={encounter.id} className={style.h2HEncounter}>
              <div className={style.h2HEncounterType}>{getMatchType(encounter)}</div>
              <div className={style.h2HEncounterTeams}>
                <TeamAvatar team={opponent1Encounter} className={style.h2HEncounterTeam} />
                <div className={style.h2HEncounterScore}>
                  <span>{opponent1Encounter?.score}</span>
                  <span> - </span>
                  <span>{opponent2Encounter?.score}</span>
                </div>
                <TeamAvatar team={opponent2Encounter} className={style.h2HEncounterTeam} />
              </div>
              <div className={style.h2HEncounterDate}>
                {formatDate(new Date(encounter.begin_at), lang, {
                  day: 'numeric',
                  month: '2-digit',
                  year: 'numeric'
                })}
              </div>
            </li>
          );
        })}
      </ul>
    </BlockGradTemplate>
  );
};

HeadToHeadBlockGrad.displayName = 'HeadToHeadBlockGrad';

export default HeadToHeadBlockGrad;
